import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { useCRM } from '../../context/CRMContext';

const UserForm = ({ user, onClose, onSave }) => {
  const { departments, roles, currentUser } = useCRM();
  
  // FIXED: Filter roles so regular tenants can't create Partners or SuperAdmins
  const availableRoles = Object.keys(roles).filter(roleKey => {
      if (currentUser.role === 'SuperAdmin') return true; // SuperAdmin sees all
      // Regular admins shouldn't see these internal roles
      return !['SuperAdmin', 'Partner', 'Platform_Seller', 'Board_Viewer'].includes(roleKey);
  });

  const [formData, setFormData] = useState(user || {
    name: '',
    email: '',
    role: 'Selger',
    team: '',
    department_id: '',
    phone: '',
    is_active: true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSave) {
      onSave(formData);
    } else {
      console.log("User saved locally:", formData);
      onClose && onClose();
    }
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Navn</label>
          <input required name="name" value={formData.name} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">E-post</label>
          <input type="email" required name="email" value={formData.email} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500" />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Rolle</label>
          <select name="role" value={formData.role} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
            {availableRoles.map(roleKey => (
              <option key={roleKey} value={roleKey}>
                {roleKey.replace('_', ' ')}
              </option>
            ))}
          </select>
          {currentUser.role !== 'SuperAdmin' && (
              <p className="text-[10px] text-slate-400 mt-1">Interne roller (Partner etc) er skjult.</p>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Avdeling / Enhet</label>
          {departments && departments.length > 0 ? (
            <select name="department_id" value={formData.department_id} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
              <option value="">-- Velg avdeling --</option>
              {departments.map(d => (
                <option key={d.department_id} value={d.department_id}>{d.name} ({d.type})</option>
              ))}
            </select>
          ) : (
            <input name="team" value={formData.team} onChange={handleChange} placeholder="Team navn..." className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500" />
          )}
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Telefon</label>
        <input name="phone" value={formData.phone} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500" />
      </div>

      <div className="flex items-center">
        <input type="checkbox" name="is_active" checked={formData.is_active} onChange={handleChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
        <label className="ml-2 block text-sm text-gray-900">Aktiv bruker</label>
      </div>

      <div className="flex justify-end pt-4">
        <button type="submit" className="flex items-center px-6 py-2 bg-slate-900 text-white rounded-xl font-bold hover:bg-slate-800 transition-colors shadow-md">
          <SafeIcon icon="💾" className="w-4 h-4 mr-2" /> Lagre Bruker
        </button>
      </div>
    </form>
  );
};

export default UserForm;